import React from 'react';
import _ from 'lodash';

import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';
import {
    Search as SearchIcon,
} from '@material-ui/icons';
import {
    createStyles, WithStyles, Paper, TableHead, Button, Link
} from '@material-ui/core';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

const styles = (theme: Theme) => createStyles({
    textSM: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 20,
        lineHeight: '16px',
        color: 'rgb(51, 51, 51)'
    },
    tableRowFont: {
        color: '#666666',
        fontSize: 16,
        lineHeight: '16px'
    },
    searchIcon: {
        fill: theme.palette.text.secondary,
        opacity: 0.5
    },
    root: {
        width: '100%',
        padding: '0px 14px',
        background: 'rgb(255 255 255)',
        borderRadius: 4
    },
    tableFooter: {
        width: '100%'
    },
    table: {
        minWidth: 500,
        '& td': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        
    },
    tableWrapper: {
        overflowX: 'auto',
        background: '#FFFFFF',
        boxSizing: 'border-box',
        borderRadius: 4
    },
    tableHead: {
        boxSizing: 'border-box',
        borderRadius: '4px 4px 0px 0px',
        height: 75
    },
    tableCell: {
        maxWidth: 130,
        padding: '18px 20px'
    },
    tableRow: {
        '& td': {
            fontSize: 16,
            lineHeight: '16px',
            color: '#666666',
            '&:nth-child(4)': {
                color: '#333333'
            }, 
            '&:nth-child(1)': {
                color: '#333333'
            }, 
        },            
        '&:nth-of-type(odd)': {
            backgroundColor: '#F8F8F8;',
        }
    }
});


interface UserTableProps extends WithStyles<typeof styles> {
    classes: any,
}

const handleChangePage = () => {

}

const UserTable = (props: UserTableProps) => {
    const {
        classes
    } = props;
    //@ts-ignore
    const [page, setPage]= React.useState(0);


    const handleChangeRowsPerPage = (event: any) => {
        // this.setState({ page: 0, rowsPerPage: event.target.value });
    };

    return (
        <>
            <Paper className={classes.root} elevation={0}>
                <div className={classes.tableWrapper}>
                    {

                    }
                    <Table classes={{ root: classes.table }} padding="checkbox">
                        <TableHead classes={{ root: classes.tableHead }}>
                            <TableRow>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">S.No</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center" >Name</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                    Address
                                </TableCell>  
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">License Validity</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">Action</TableCell>
                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key={1} classes={{root: classes.tableRow}}>
                                <TableCell classes={{ root: classes.tableCell }}  align="center">
                                    1.
                                </TableCell>                                        
                                <TableCell classes={{ root: classes.tableCell }} align="center">
                                Glorifire
                                </TableCell>
                                <TableCell classes={{ root: classes.tableCell }} align="center">
                                    Kalu Sarai, New Delhi – 110016
                                </TableCell>
                                <TableCell classes={{ root: classes.tableCell }} align="center">
                                    31/03/2021
                                </TableCell>
                                <TableCell classes={{ root: classes.tableCell }} align="center">
                                    <Link href="#" variant="body2" underline="none">
                                        Edit
                                    </Link>
                                </TableCell>
                               
                            </TableRow>

                            <TableRow key={2} classes={{root: classes.tableRow}}>
                            <TableCell classes={{root: classes.tableCell }} component="th" scope="row" align="center">
                                    2.
                                </TableCell>                                        
                                <TableCell classes={{ root: classes.tableCell }} align="center">
                                    Glorifire
                                </TableCell>
                                <TableCell classes={{ root: classes.tableCell }} align="center">
                                    Kalu Sarai, New Delhi – 110016
                                </TableCell>
                                <TableCell classes={{root: classes.tableCell }} align="center">
                                    31/03/2021
                                </TableCell>
                                <TableCell classes={{root: classes.tableCell }} align="center">
                                    <Link href="#" variant="body2" underline="none">
                                        Edit
                                    </Link>
                                </TableCell>
                               
                            </TableRow>

                        </TableBody>
                        <TableFooter classes={{ root: classes.tableFooter }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10]}
                                    //colSpan={12}
                                    count={12}
                                    rowsPerPage={10}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onChangePage={handleChangePage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        </>

    );
};

export default withStyles(styles)(UserTable);